module.exports = __webpack_public_path__ + "img/Carousel2.7edff565.png";